import * as actionType from "../ActionTypes";
import * as mutationType from "../MutationType";
import api from "../../config/api";

const state = {
};
const getters = {
};

const actions = {
  [actionType.GET_DISCOUNT_CODE]: async function ({ commit }, params) {
    return new Promise((resolve, reject) => {
      api.get("admin/discount-codes",{params}).then(result => {
        resolve(result);
      })
        .catch(error => reject(error));
    });
  },
  [actionType.GET_DISCOUNT_CODE_DETAILS]: async function ({ commit }, params) {
    return new Promise((resolve, reject) => {
      api.get(`admin/discount-codes/${params.id}`,{params}).then(result => {
        resolve(result);
      })
        .catch(error => reject(error));
    });
  },
  [actionType.DELETE_DISCOUNT]: async function ({ commit }, params) {
    return new Promise((resolve, reject) => {
      api.delete(`admin/discount-codes/${params.id}`).then(result => {
        resolve(result);
      })
        .catch(error => reject(error));
    });
  },
  [actionType.ENABLE_DISABLE_DISCOUNT_CODE]: async function ({ commit }, params) {
    return new Promise((resolve, reject) => {
      api.put(`admin/discount-codes/${params.id}/active`,).then(result => {
        resolve(result);
      })
        .catch(error => reject(error));
    });
  },
  [actionType.UPDATE_DISCOUNT_CODE]: async function ({ commit }, params) {
    return new Promise((resolve, reject) => {
      api.put(`admin/discount-codes/${params.id}`,params).then(result => {
        resolve(result);
      })
        .catch(error => reject(error));
    });
  },
  [actionType.CREATE_DISCOUNT_CODE]: async function ({ commit }, params) {
    return new Promise((resolve, reject) => {
      api.post(`admin/discount-codes`,params).then(result => {
        resolve(result);
      })
        .catch(error => reject(error));
    });
  },
};

const mutations = {
  
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}